export default {
  maroon: "700C0C",
  lightBlue: "4ABEFF",
  darkBlue: "007ABF",
  lightGray: "EAEAEA",
  mediumGray: "DEDEDE",
  red: "E74725",
  darkGreen: "1AB700",
  green: "1FDD00",
  lightGreen: "7CFF67",
  darkGray: "9D9D9D"
};
